import React, { Component } from 'react'
import Select from 'react-select'
import _ from 'lodash'
import { renderRoom } from '../formatters/roomFormatter'
import { getRoomConfigurationDisplayName } from '../../logic/roomLogic'
import Input from '../elements/input'

const SelectInput = ({ label, ...otherProps }) => (
  <Input label={label}>
    <Select {...otherProps} />
  </Input>
)

export const RoomPicker = ({ value, options, onChange }) => {
  /* There is a bug with this select component (or redux form)
   that causes onBlur event to clear the value.
   So we explicitly pass value and onChange properties, and not
   the rest */
  return (
    <SelectInput
      label={'Room'}
      placeholder='Choose a room...'
      value={value}
      valueRenderer={renderRoom}
      options={options}
      optionRenderer={renderRoom}
      clearable={false}
      onChange={onChange}
    />
  )
}

const ConfigurationValueRenderer = ({ roomConfiguration }) => (
  <span>{getRoomConfigurationDisplayName(roomConfiguration)}</span>
)

const ConfigurationOptionRenderer = ({
  roomConfiguration,
  canBook,
  reason
}) => (
  <div>
    <ConfigurationValueRenderer roomConfiguration={roomConfiguration} />
    {!canBook && <div style={{ fontSize: '13px' }}>{reason}</div>}
  </div>
)

export class RoomConfigurationPicker extends Component {
  /**
   * If the selected value is not one of the options, reset the selected value
   */
  componentDidUpdate(prevProps, prevState) {
    const {
      roomConfiguration,
      roomConfigurations,
      onRoomConfigurationChange
    } = this.props

    if (
      roomConfiguration !== '' &&
      prevProps.roomConfigurations !== roomConfigurations &&
      !_.includes(
        _(roomConfigurations)
          .filter(config => !config.disabled)
          .map('value')
          .value(),
        roomConfiguration
      )
    ) {
      onRoomConfigurationChange('')
    }
  }

  render() {
    const {
      roomConfiguration,
      onRoomConfigurationChange,
      roomConfigurations
    } = this.props
    return (
      <SelectInput
        label={'Room Configuration'}
        placeholder={'Select Room Configuration'}
        options={roomConfigurations}
        optionRenderer={ConfigurationOptionRenderer}
        valueRenderer={ConfigurationValueRenderer}
        value={roomConfiguration}
        onChange={onRoomConfigurationChange}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/roomSelectionFormElements.js